/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：292
 */

"use strict"

function r(e) {
  return null != e && "object" === typeof e && true === e["@@functional/placeholder"]
}
export { r as a }
export default r
